import { useState } from 'react';
import { LocationItem } from '../components/LocationSelector';

const useCampaignFormState = () => {
  const [campaignName, setCampaignName] = useState('');
  const [selectedGameId, setSelectedGameId] = useState('');
  const [selectedAudienceId, setSelectedAudienceId] = useState('');
  const [newAudienceName, setNewAudienceName] = useState('');
  const [newGender, setNewGender] = useState<string[]>([]);
  const [newAgeRange, setNewAgeRange] = useState<[number, number]>([18, 65]);
  const [locations, setLocations] = useState<LocationItem[]>([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [dailyBudget, setDailyBudget] = useState(10);

  const totalDays =
    startDate && endDate
      ? Math.ceil(
          (new Date(endDate).getTime() - new Date(startDate).getTime()) /
            (1000 * 60 * 60 * 24) + 1,
        )
      : 0;

  const audienceIsValid =
    selectedAudienceId.trim() !== '' ||
    (newAudienceName.trim() !== '' &&
      newGender.length > 0 &&
      newAgeRange[0] !== 0 &&
      newAgeRange[1] !== 0 &&
      locations.length > 0);

  const formIsValid =
    campaignName.trim() !== '' &&
    selectedGameId.trim() !== '' &&
    audienceIsValid &&
    startDate.trim() !== '' &&
    endDate.trim() !== '' &&
    dailyBudget > 0;

  return {
    campaignName,
    setCampaignName,
    selectedGameId,
    setSelectedGameId,
    selectedAudienceId,
    setSelectedAudienceId,
    newAudienceName,
    setNewAudienceName,
    newGender,
    setNewGender,
    newAgeRange,
    setNewAgeRange,
    locations,
    setLocations,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    dailyBudget,
    setDailyBudget,
    totalDays,

    formIsValid,
  };
};

export default useCampaignFormState;
